import { Box, Button, CloudinaryImage, Text } from '@stitch-fix/mode-react';
import styles from './AndroidNoGallery.module.scss';
import { useAndroidPushNotifications } from '../../../../utils/android';
export const AndroidNoGallery = () => {
  const {
    canRequestNotifications,
    notificationsEnabled,
    requestNotificationPermission,
    initialNotificationsEnabled
  } = useAndroidPushNotifications();
  const showNotificationsButton = canRequestNotifications && initialNotificationsEnabled === false;
  return <Box className={styles.noGalleryContainer}>
      <Box pt={0.2} pb={1} className={styles.visionHeading}>
        <Text color="blue-45" setting="title-small" align="center" as="h2">
          Stitch Fix Vision
        </Text>
      </Box>
      <Text color="blue-45" setting="display-medium" align="center">
        Your Vision <strong>Gallery</strong>
      </Text>
      <Text mt={2} mx={2.5} setting="body-large" align="center">
        <strong>Check back in about 10 minutes for your first images.</strong>
      </Text>
      <Box className={styles.noGalleryBackground} my={1.5}>
        <CloudinaryImage baseUrl="https://res.cloudinary.com/stitch-fix/image/upload/" mediaPath="v1757013953/vision/assets/9-2-loading-gallery.gif" sizes={{
        sm: 600
      }} transforms={{
        f: 'auto',
        q: 'auto'
      }} alt="" objectFit="cover" />
      </Box>
      <Box p={1} className={styles.noGalleryContent}>
        <Text mx={2.5} setting="body-medium">
          {showNotificationsButton ? 'Be sure to turn on notifications to get weekly gallery updates.' : ''}
        </Text>
        {showNotificationsButton && !notificationsEnabled && <Button width="fill" mt={1.5} onClick={requestNotificationPermission}>
            Turn on weekly Notifications
          </Button>}
        {showNotificationsButton && notificationsEnabled && <Text align="center" setting="body-small" mt={2}>
            Perfect—we’ll notify you about new arrivals in your gallery.
          </Text>}
        {!showNotificationsButton && <Button width="fill" mt={1.5} as="a" href="/home">
            Back to home
          </Button>}
      </Box>
    </Box>;
};